module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog confirm-api-key-disable-modal\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <h5 class=\"modal-title\">Are you sure you want to disable this key?</h5> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> </section> <form> <section class=\"modal-body\"> <p>")
    ; __append(escapeFn( locals.apiKey ))
    ; __append("</p> <p>Disabling an API key immediately renders it unusable.</p> </section> <section class=\"modal-footer\"> <button class=\"btn btn-clear cancel\" type=\"button\">Cancel</button> <button class=\"btn btn-danger disable-api-key\" type=\"button\">Disable Key</button> </section> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/confirm_api_key_disable_modal.ejs
// module id = 1208
// module chunks = 1